export default __webpack_public_path__ + "static/media/company-animate.7626c0ec.svg";